module.exports = __webpack_public_path__ + "static/media/04d.f984fe91.svg";